import React, { useEffect, useState } from "react";
import { relations } from "../../../../utility/data";
import {
  FormActions,
  FormDropdown,
  InputField,
} from "../../../../components/Stepper/fields/inputField";
import { FaTimes } from "react-icons/fa";

const AddLegacy = ({ onClose, handleSubmit, type, selectedGroup }) => {
  const [formData, setFormData] = useState({
    name: "",
    relation: relations[0],
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (type === "edit" && selectedGroup) {
      setFormData({
        name: selectedGroup.name || "",
        relation: selectedGroup.relation || null,
      });
      setErrors({});
    } else {
      setFormData({ name: "", relation: relations[0] });
      setErrors({});
    }
  }, [selectedGroup, type]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const handleFormSubmit = () => {
    let newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Legacy name is required.";
    }
    if (!formData.relation) {
      newErrors.relation = "Relation is required.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);

    handleSubmit({
      name: formData.name,
      relation: formData.relation,
      onClose,
      setError: (error) => setErrors({ form: error }),
      setLoading,
    });
  };

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50 overflow-y-auto">
      <div className="dark:bg-custom-radial bg-[#F6F6F6] rounded-lg w-[400px] shadow-lg p-6 text-[rgba(255,255,255,1)] md:w-1/3 w-full max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-semibold text-lightPrimary dark:text-primary-gradient">
            {type === "edit" ? "Edit Legacy" : "Add Legacy"}
          </h2>
          <button
            onClick={onClose}
            className="text-lightPrimary dark:text-darkWaring focus:outline-none"
          >
            <FaTimes fontSize={20}/>
          </button>
        </div>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleFormSubmit();
          }}
        >
          <div className="mb-4">
            <InputField
              label="Legacy Name*"
              placeholder="Enter legacy name"
              name="legacyName"
              value={formData.name}
              onChange={(e) => handleChange("name", e.target.value)}
              required={false}
              errors={errors.name}
            />
          </div>

          <FormDropdown
            label="Relation"
            value={formData.relation}
            name="relation"
            onChange={(e) => handleChange("relation", e.value)}
            options={relations}
            placeholder="Select relation"
            optionsLabel="name"
            error={errors.relation}
            className={`rounded-lg w-full p-0 bg-transparent border border-info dark:border-grey text-white focus:outline-none focus:border-b-2 ${
              errors.relation ? "border-red-500" : ""
            }  ${formData.relation ? "asset_Dropdown" : ""}`}
            containerClassName="col-span-2"
            labelClassName="block mb-2 text-lg text-info dark:text-grey font-medium"
            mainClassName="w-full mb-4"
          />

          <FormActions
            loading={loading}
            onCancel={onClose}
            actionType={type}
            className="justify-end"
            submitType="submit"
          />
        </form>
      </div>
    </div>
  );
};

export default AddLegacy;
